import * as types from './mutation-types';

export default {
  [types.SET_ORIGEM_COLLECTION](state, payload) {
    state.origemCollection = payload;
  },
};
